import React from "react";
import PropTypes from "prop-types";
import { Button, Plus, Tabs } from "@opendate-app/setlist";
import { MAX_TICKET_SETS, colorOf } from "../ticketSets";

const dots = {};
export const SetDot = ({ color }) => <span className={`series-set-dot series-set-color-${color}`} aria-hidden="true" />;
SetDot.propTypes = { color: PropTypes.string.isRequired };
const dotIcon = (color) => {
  if (!dots[color]) {
    const Dot = () => <SetDot color={color} />;
    Dot.displayName = `SetDot(${color})`;
    dots[color] = Dot;
  }
  return dots[color];
};

const TicketSetTabs = ({ sets, activeKey, typeCounts, onSelect, onAdd, locked }) => (
  <div className="series-set-tabs">
    <Tabs
      aria-label="Ticket sets"
      collapseBelow={0}
      value={activeKey}
      items={sets.map((set) => ({
        value: set.key,
        label: set.name,
        count: typeCounts[set.key] || 0,
        icon: dotIcon(colorOf(sets, set.key)),
      }))}
      onChange={onSelect}
    />
    <Button variant="link-gray" size="sm" icon={Plus} disabled={locked || sets.length >= MAX_TICKET_SETS} onClick={onAdd}>
      Add ticket set
    </Button>
  </div>
);

TicketSetTabs.propTypes = {
  sets: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeKey: PropTypes.string.isRequired,
  typeCounts: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  locked: PropTypes.bool,
};

export default TicketSetTabs;
